var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lg:bg-hero-pattern lg:bg-repeat-round bg-repeat-space lg:h-screen"},[_c('div',{staticClass:"lg:bg-white bg-gray-200 lg:bg-opacity-50 sm:p-20 p-5 content-center lg:h-screen"},[_c('ContactPanel')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }